import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { getPasswordRequirements } from '~/components/Auth/passwordRequirements';
import { Card } from '~/components/Card';
import { ServicesContext } from '~/services';
import { Form, FormGroup, ValidationMessage } from '~/components/Form';
import { Spinner } from 'react-bootstrap';

// Type assertions for TypeScript 5.x compatibility with react-router-dom v5
const RedirectComponent = Redirect as any;
const LinkComponent = Link as any;

export function Reset() {
    const servicesContext = React.useContext(ServicesContext);

    const [loading, setLoading] = React.useState(false);
    const [responseMessage, setResponseMessage] = React.useState(false);
    const [submitted, setSubmitted] = React.useState(false);
    const [validation, setValidation] = React.useState(false);
    const [redirectPath, setRedirectPath] = React.useState('');
    const [pw, setPw] = React.useState('');
    const [confirmpw, setConfirmpw] = React.useState('');

    async function handleSubmit() {
        try {
            setLoading(true);
            const { message, responseCode } = await servicesContext.user.passwordReset(pw);
            setResponseMessage(message);
            setSubmitted(true);
            setRedirectPath(responseCode === 1017 ? `/?response-code=${responseCode}` : '/');
        } catch (e) {
            setLoading(false);
            setValidation(true);
            setResponseMessage(e.response);
        }
    }

    function isWelcome() {
        return servicesContext.user.getResetEndpoint() === '/welcome';
    }

    React.useEffect(() => {
        if (!window.app.reset_password || !window.app.reset_password.ready) {
            setRedirectPath('/');
        }
    }, []);

    if (redirectPath) {
        delete window.app.reset_password;
        return <RedirectComponent to={redirectPath} />;
    }

    return (
        <Card title={isWelcome() ? 'Create Your Password' : 'Reset Your Password'}>
            {!submitted ? (
                <Form onSubmit={handleSubmit} values={{ pw, confirmpw }} autoComplete="off">
                    <FormGroup htmlFor="pw" className="mb-3 row">
                        <label htmlFor="pw" className="col-12 col-sm-5 col-lg-4 col-form-label">
                            New Password
                        </label>
                        <div className="col-12 col-sm-7 col-lg-8">
                            <input
                                type="password"
                                required
                                className="form-control"
                                id="pw"
                                value={pw}
                                onChange={(e) => setPw(e.target.value)}
                            />
                        </div>
                        <ValidationMessage
                            type="required"
                            className="offset-sm-5 offset-lg-4 col-12 col-sm-7 col-lg-8"
                        >
                            Password is required.
                        </ValidationMessage>
                        <ValidationMessage
                            type="external"
                            rule={validation}
                            className="offset-sm-5 offset-lg-4 col-12 col-sm-7 col-lg-8"
                        >
                            {Array.isArray(responseMessage)
                                ? responseMessage.map((x) => <div key={x.message}>{x.message}</div>)
                                : responseMessage}
                        </ValidationMessage>
                    </FormGroup>
                    <FormGroup htmlFor="confirmpw" className="mb-3 row">
                        <label
                            htmlFor="confirmpw"
                            className="col-12 col-sm-5 col-lg-4 col-form-label"
                        >
                            Confirm Password
                        </label>
                        <div className="col-12 col-sm-7 col-lg-8">
                            <input
                                type="password"
                                data-match="pw"
                                required
                                className="form-control"
                                id="confirmpw"
                                value={confirmpw}
                                onChange={(e) => setConfirmpw(e.target.value)}
                            />
                        </div>
                        <ValidationMessage
                            type="required"
                            className="offset-sm-5 offset-lg-4 col-12 col-sm-7 col-lg-8"
                        >
                            Password confirmation is required.
                        </ValidationMessage>
                        <ValidationMessage
                            type="match"
                            className="offset-sm-5 offset-lg-4 col-12 col-sm-7 col-lg-8"
                        >
                            Passwords must match.
                        </ValidationMessage>
                    </FormGroup>
                    {getPasswordRequirements()}
                    <div className="row">
                        <div className="col text-end">
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading && (
                                    <Spinner
                                        animation="border"
                                        variant="light"
                                        size="sm"
                                        role="status"
                                        className="me-1"
                                    />
                                )}
                                Reset
                            </button>
                        </div>
                    </div>
                </Form>
            ) : (
                <div>
                    <p>{responseMessage}</p>
                    <div>
                        <LinkComponent to="/">Click here</LinkComponent> to return to the login
                        page.
                    </div>
                </div>
            )}
        </Card>
    );
}
